"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGLineChart = void 0;
const react_1 = __importStar(require("react"));
const line_1 = require("@nivo/line");
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const gen5_shared_utilities_1 = require("@terragotech/gen5-shared-utilities");
const configContext_1 = require("../../../contexts/configContext");
const TGLineChart = (props) => {
    const { defaultDateTimeFormat } = configContext_1.useConfig();
    const { dateFormat, dateTimeFormat } = react_1.useMemo(() => ({
        dateFormat: gen5_shared_utilities_1.getDateFormat(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, { datePartOnly: true, tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
        dateTimeFormat: gen5_shared_utilities_1.getDateTimeFormat(defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormatType, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateFormat, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.dateSeperator, defaultDateTimeFormat === null || defaultDateTimeFormat === void 0 ? void 0 : defaultDateTimeFormat.timeFormat, { tokenConversion: gen5_shared_utilities_1.DATETIME_TOKEN_CONVERSION.MomentJS }),
    }), [defaultDateTimeFormat]);
    const { isXAxisDate, isYAxisDate } = react_1.useMemo(() => props.data.reduce((acc, serie) => {
        var _a, _b;
        return ({
            isXAxisDate: acc.isXAxisDate || ((_a = serie.data) === null || _a === void 0 ? void 0 : _a.some(d => lodash_1.isDate(d.x))),
            isYAxisDate: acc.isYAxisDate || ((_b = serie.data) === null || _b === void 0 ? void 0 : _b.some(d => lodash_1.isDate(d.y))),
        });
    }, { isXAxisDate: false, isYAxisDate: false }), [props.data]);
    const formatDateValue = (value) => {
        const local = moment_1.default(value);
        return local.millisecond() === 0 ? moment_1.default.utc(value).format(dateFormat) : local.format(dateTimeFormat);
    };
    return props.data.reduce((prev, curr) => {
        var _a;
        return prev || !((_a = curr.data) === null || _a === void 0 ? void 0 : _a.length);
        // TODO: [S5-3487] Issue with React 18? https://stackoverflow.com/questions/71841181/some-components-cannot-be-used-as-a-jsx-component
        // @ts-ignore
    }, false) ? react_1.default.createElement("div", null, "No results") : react_1.default.createElement(line_1.ResponsiveLine, Object.assign({}, props, { margin: { top: 50, right: 110, bottom: 50, left: 60 }, xScale: {
            type: isXAxisDate ? 'time' : 'point',
            nice: true,
        }, xFormat: isXAxisDate ? formatDateValue : undefined, yScale: {
            type: isYAxisDate ? 'time' : 'linear',
            nice: true,
            min: 'auto',
            max: 'auto',
        }, yFormat: isYAxisDate ? formatDateValue : " >-.2f", axisTop: null, axisRight: null, axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -20,
            truncateTickAt: 0,
            format: isXAxisDate ? formatDateValue : undefined,
        }, axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            truncateTickAt: 0,
            format: isYAxisDate ? formatDateValue : undefined,
        }, pointSize: 10, pointColor: { theme: 'background' }, pointBorderWidth: 2, pointBorderColor: { from: 'serieColor' }, pointLabel: "data.yFormatted", pointLabelYOffset: -12, enableTouchCrosshair: true, useMesh: true, legends: props.data.length > 1 ? [
            {
                anchor: 'bottom-right',
                direction: 'column',
                justify: false,
                translateX: 100,
                translateY: 0,
                itemsSpacing: 0,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 20,
                itemOpacity: 0.75,
                symbolSize: 12,
                symbolShape: 'circle',
                symbolBorderColor: 'rgba(0, 0, 0, .5)',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1,
                        },
                    },
                ],
            },
        ] : [] }));
};
exports.TGLineChart = TGLineChart;
exports.default = exports.TGLineChart;
//# sourceMappingURL=TGLineChart.js.map